import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateEntityAchievements, UpdateAchievementPayload } from "../services/achievements.service";
import { entityKeys } from "../queryKeys";
import { AchievementsResponse } from "../types/achievements.types";

interface UpdateEntityAchievementsParams {
  entityId: string;
  data: UpdateAchievementPayload;
}

export const useUpdateEntityAchievements = () => {
  const queryClient = useQueryClient();

  return useMutation<AchievementsResponse, Error, UpdateEntityAchievementsParams>({
    mutationFn: ({ entityId, data }: UpdateEntityAchievementsParams) => {
      return updateEntityAchievements(entityId, data);
    },
    onSuccess: (_, { entityId }) => {
      queryClient.invalidateQueries({ queryKey: entityKeys.achievements(entityId) });
      queryClient.invalidateQueries({ queryKey: entityKeys.details(entityId) });
    },
  });
};
